import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectIsCompareAdded } from '../../selectors/compare';
import { toggleCompare } from '../../slices/compare';
import { TDispatch } from '../../types/redux';
import { useApplicationContext } from '../../utils/applicationContext';
import { CompareButtonControl } from './CompareButtonControl';
import { CompareButtonOnboarding } from './CompareButtonOnboarding';
import { COMPARE_ENABLED_CONFIG } from './constants';
import { useCompareOnboarding } from './useCompareOnboarding';

interface INewbuildingCompareButtonProps {
  hideText?: boolean;
  isHeader?: boolean;
  withOnboarding?: boolean;
}

export const NewbuildingCompareButton: React.FC<INewbuildingCompareButtonProps> = ({
  hideText = false,
  isHeader = false,
  withOnboarding = false,
}) => {
  const { config } = useApplicationContext();
  const dispatch = useDispatch<TDispatch>();
  const isAdded = useSelector(selectIsCompareAdded);
  const isCompareEnabled = config.get<boolean>(COMPARE_ENABLED_CONFIG) || false;
  const { open, closeHandler } = useCompareOnboarding(withOnboarding && isCompareEnabled);

  const handleClick = React.useCallback(() => {
    dispatch(toggleCompare());
  }, [dispatch]);

  if (!isCompareEnabled) {
    return null;
  }

  const button = (
    <CompareButtonControl hideText={hideText} isHeader={isHeader} isAdded={isAdded} onClick={handleClick} />
  );

  if (!withOnboarding || !open) {
    return button;
  }

  return (
    <CompareButtonOnboarding open={open} onClose={closeHandler}>
      {button}
    </CompareButtonOnboarding>
  );
};
